import { pakistanCellNumberPattern } from "@schemas/validationPatterns";
import z from "zod";

export const createProfileSchema = (t: (key: string) => string) => {
	return z.object({
		firstName: z.string().min(1, t("psdaCommon.profile.form.validations.firstName")),
		lastName: z.string().min(1, t("psdaCommon.profile.form.validations.lastName")),
		phoneNumber: z
			.string()
			.regex(pakistanCellNumberPattern, "Format should be 03xx")
			.min(1, t("psdaCommon.profile.form.validations.cellNo")),
		// email: z.string().email(t("psdaCommon.profile.form.validations.emailRequired")),
		emailAddress: z.string({ required_error: t("psdaCommon.profile.form.validations.emailRequired") })
			.min(1, t("psdaCommon.profile.form.validations.emailRequired"))
			.email(t("psdaCommon.profile.form.validations.validEmail")),
	});
};
